import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  TextField,
  Toolbar,
  useMediaQuery
} from '@mui/material';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import {
  CmpButtonWithIcon,
  CmpDatePickerField,
  CmpTypographyField
} from '../../../component/ToolBox/ToolBox';
import { useSelector } from 'react-redux';
import moment from 'moment';
import CloseIcon from '@mui/icons-material/Close';
import { DataGridPro } from '@mui/x-data-grid-pro';
import { ItemTransferGetrow, ItemTransferSave } from '../actions';
import { DataGrid } from '@mui/x-data-grid';
import { Refresh } from '@mui/icons-material';
import { fAlertToast } from '../../../Utility/Utilitys';
import { confirmAlert } from 'react-confirm-alert';
import PrintOutlinedIcon from '@mui/icons-material/PrintOutlined';
import Tooltip from '@mui/material/Tooltip';

export const StockTransferModalComp = ({
  open,
  onClose,
  headObj,
  xMediaQuery,
  fOnPageLoad,
  setSelectedDetailData
}) => {
  const toolbar = {
    backgroundColor: '#0d73bb',
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    minHeight: '40px !important'
  };
  const vMediaQuery = useMediaQuery('(max-width: 900px)');
  const rdxUser = useSelector((state) => state.SliceDB.value);
  console.log('headObj', headObj);

  const [detailItems, setDetailItems] = useState([]);
  const qtyRefs = useRef({});
  const [reportModalOpen, setReportModalOpen] = useState(false);
  const [reportUrl, setReportUrl] = useState('');

  const fStockTransferDetailGetrow = async () => {
    const obj = {
      TransId: headObj?.A_TransId,
      UserCd: rdxUser.login.userId
    };
    const result = await ItemTransferGetrow(obj);
    console.log(result, 'result');
    if (result.Type == 'Success') {
      if (result?.ResultSet?.length > 0) {
        setDetailItems(result.ResultSet);
      } else {
        setDetailItems([]);
      }
    }

    return result.ResultSet;
  };

  const fSaveCheck = (isPost) => {
    for (const item of detailItems) {
      if (item.UnitRate < item.CostPrice) {
        if (item.AllowBelowCost) {
          confirmAlert({
            title: 'Below Cost Confirmation',
            message: `Item "${item.ItemName}" is below cost. Do you want to continue?`,
            buttons: [
              {
                label: 'Yes',
                onClick: async () => {
                  console.log('User confirmed for RowId:', item.RowId);
                  await fSave(isPost);
                }
              },
              {
                label: 'No',
                onClick: () => {
                  console.log('User cancelled.');
                }
              }
            ]
          });
        } else {
          fAlertToast('FAILED', `Item "${item.ItemName}" is below cost and not allowed!`);
        }
        return;
      }
    }

    if (isPost) {
      fPost(isPost);
    } else {
      fSave(isPost);
    }
  };

  const fSave = async (isPost) => {
    try {
      const detailPayload = detailItems?.map((obj) => ({
        ItmCd: obj?.B_ItmCd,
        Unit: obj?.B_Unit,
        Qty: Number(obj?.B_Qty),
        UnitRate: Number(obj?.UnitRate),
        B_UOM_PCS: obj?.B_UOM_PCS,
        B_UOM_PackQty: obj?.B_UOM_PackQty,
        KgCost: obj?.KgCost
      }));

      const obj = {
        TransId: headObj?.A_TransId,
        userCd: rdxUser.login.userId,
        details: detailPayload,
        isPost
      };
      const res = await ItemTransferSave(obj);
      if (res.Type === 'Success') {
        if (isPost) {
          fAlertToast('SUCCESS', 'Posted Successful');
          fOnPageLoad();
          setSelectedDetailData((prev) => ({
            ...prev,
            A_Status: true
          }));
        } else {
          fAlertToast('SUCCESS', 'Saved Successful');
        }
        // fOnPageLoad();
      }
    } catch (error) {}
  };

  const fPost = async (isPost) => {
    confirmAlert({
      title: 'Post',
      message: `Are you want to Post?`,
      buttons: [
        {
          label: 'Yes',
          onClick: async () => {
            await fSave(isPost);
          }
        },
        {
          label: 'No',
          onClick: () => {
            console.log('User cancelled.');
          }
        }
      ]
    });
  };
  useEffect(() => {
    if (open) {
      fStockTransferDetailGetrow();
    }
  }, [open]);

  const columns = [
    {
      field: 'B_ItmCd',
      headerName: 'ItmCd',
      align: 'left',
      headerAlign: 'left',
      valueFormatter: ({ value }) => Number(value).toFixed(0),
      width: 110
    },
    {
      field: 'ItemName',
      headerName: xMediaQuery ? 'Item' : ' ItemName',
      flex: 1,
      minWidth: 120,
      align: 'left',
      headerAlign: 'left'
    },
    {
      field: 'B_UOM_PCS',
      headerName: 'PCS/CTN',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0)
    },
    {
      field: 'B_UnitName',
      headerName: 'Unit',
      hide: false,
      align: 'left',
      headerAlign: 'left',
      width: 100
    },

    {
      field: 'B_PackDesc',
      headerName: 'Packing ',
      align: 'left',
      headerAlign: 'left',
      width: 90
    },
    {
      field: 'B_ReqQty',
      headerName: 'Req.Qty',
      align: 'center',
      headerAlign: 'center',
      width: 90,
      renderCell: (params) => {
        const value = (params.row?.B_ReqQty).toFixed(2);
        return <span>{value ?? ''}</span>;
      }
    },
    {
      field: 'B_PurRatio',
      headerName: 'Pur.Ration',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0)
    },
    {
      field: 'SuggestedCTN',
      headerName: 'Suggested',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0)
    },

    {
      field: 'CostPrice',
      headerName: 'CostPrice',
      width: 100,
      align: 'center',
      headerAlign: 'center',
      valueFormatter: ({ value }) => Number(value).toFixed(0)
    },

    {
      field: 'KgCost',
      headerName: 'Cost/Kg',
      align: 'center',
      headerAlign: 'center',
      width: 100,
      renderCell: (params) => {
        const { row } = params;

        return (
          <TextField
            inputRef={(el) => (qtyRefs.current[row.RowId] = el)}
            value={row?.KgCost ?? ''}
            onFocus={() => {
              // Clear 0 on focus
              if (Number(row?.KgCost) === 0) {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, KgCost: '' } : item))
                );
              }
            }}
            onBlur={(e) => {
              // Reset empty to 0 on blur
              if (e.target.value === '') {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, KgCost: 0 } : item))
                );
              }
            }}
            onChange={(e) => {
              const val = e.target.value;
              // Allow numeric or empty only
              if (val === '' || (/^\d*\.?\d*$/.test(val) && Number(val) >= 0)) {
                setDetailItems((prev) =>
                  prev.map((item) =>
                    item.RowId === row.RowId
                      ? { ...item, KgCost: val, UnitRate: val * row.B_UOM_PackQty * row.B_UOM_PCS }
                      : item
                  )
                );
              }
            }}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key.toLowerCase() === 'e') e.preventDefault();
              if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key))
                e.stopPropagation();

              if (e.key === 'Enter') {
                e.preventDefault();
                // Save current value
                setDetailItems((prev) =>
                  prev.map((item) =>
                    item.RowId === row.RowId ? { ...item, B_Qty: e.target.value } : item
                  )
                );

                // Focus next row Qty
                const currentIndex = detailItems.findIndex((item) => item.RowId === row.RowId);
                const nextItem = detailItems[currentIndex + 1];
                if (nextItem && qtyRefs.current[nextItem.RowId]) {
                  qtyRefs.current[nextItem.RowId].focus();
                }
              }
            }}
            autoComplete="off"
            variant="outlined"
            size="small"
            inputProps={{
              inputMode: 'decimal',
              type: 'text',
              style: { textAlign: 'right' }
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-input': {
                padding: '4px 8px',
                fontSize: '13px',
                backgroundColor: '#edfaff',
                justifyContent: 'center',
                textAlign: 'center'
              }
            }}
          />
        );
      }
    },

    {
      field: 'B_Qty',
      headerName: 'Qty',
      align: 'center',
      headerAlign: 'center',
      width: 100,
      renderCell: (params) => {
        const { row } = params;

        return (
          <TextField
            inputRef={(el) => (qtyRefs.current[row.RowId] = el)}
            value={row?.B_Qty ?? ''}
            onFocus={() => {
              // Clear 0 on focus
              if (Number(row?.B_Qty) === 0) {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, B_Qty: '' } : item))
                );
              }
            }}
            onBlur={(e) => {
              // Reset empty to 0 on blur
              if (e.target.value === '') {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, B_Qty: 0 } : item))
                );
              }
            }}
            onChange={(e) => {
              const val = e.target.value;
              // Allow numeric or empty only
              if (val === '' || (/^\d*\.?\d*$/.test(val) && Number(val) >= 0)) {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, B_Qty: val } : item))
                );
              }
            }}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key.toLowerCase() === 'e') e.preventDefault();
              if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key))
                e.stopPropagation();

              if (e.key === 'Enter') {
                e.preventDefault();
                // Save current value
                setDetailItems((prev) =>
                  prev.map((item) =>
                    item.RowId === row.RowId ? { ...item, B_Qty: e.target.value } : item
                  )
                );

                // Focus next row Qty
                const currentIndex = detailItems.findIndex((item) => item.RowId === row.RowId);
                const nextItem = detailItems[currentIndex + 1];
                if (nextItem && qtyRefs.current[nextItem.RowId]) {
                  qtyRefs.current[nextItem.RowId].focus();
                }
              }
            }}
            autoComplete="off"
            variant="outlined"
            size="small"
            inputProps={{
              inputMode: 'decimal',
              type: 'text',
              style: { textAlign: 'right' }
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-input': {
                padding: '4px 8px',
                fontSize: '13px',
                backgroundColor: '#edfaff',
                justifyContent: 'center',
                textAlign: 'center'
              }
            }}
          />
        );
      }
    },

    {
      field: 'UnitRate',
      headerName: 'UnitRate',
      align: 'center',
      headerAlign: 'center',
      width: 100,
      renderCell: (params) => {
        const { row } = params;

        return (
          <TextField
            inputRef={(el) => (qtyRefs.current[row.RowId] = el)}
            value={row?.UnitRate ?? ''}
            onFocus={() => {
              // Clear 0 on focus
              if (Number(row?.UnitRate) === 0) {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, UnitRate: '' } : item))
                );
              }
            }}
            onBlur={(e) => {
              const val = e.target.value === '' ? 0 : parseFloat(e.target.value);
              setDetailItems((prev) =>
                prev.map((item) =>
                  item.RowId === row.RowId ? { ...item, UnitRate: Number(val).toFixed(2) } : item
                )
              );
            }}
            onChange={(e) => {
              const val = e.target.value;
              if (val === '' || (/^\d*\.?\d*$/.test(val) && Number(val) >= 0)) {
                setDetailItems((prev) =>
                  prev.map((item) => (item.RowId === row.RowId ? { ...item, UnitRate: val } : item))
                );
              }
            }}
            onKeyDown={(e) => {
              if (e.key === '-' || e.key.toLowerCase() === 'e') e.preventDefault();
              if (['ArrowUp', 'ArrowDown', 'ArrowLeft', 'ArrowRight'].includes(e.key))
                e.stopPropagation();

              if (e.key === 'Enter') {
                e.preventDefault();
                // Save and format to two decimals
                setDetailItems((prev) =>
                  prev.map((item) =>
                    item.RowId === row.RowId
                      ? { ...item, UnitRate: Number(e.target.value || 0).toFixed(2) }
                      : item
                  )
                );

                // Focus next row Qty
                const currentIndex = detailItems.findIndex((item) => item.RowId === row.RowId);
                const nextItem = detailItems[currentIndex + 1];
                if (nextItem && qtyRefs.current[nextItem.RowId]) {
                  qtyRefs.current[nextItem.RowId].focus();
                }
              }
            }}
            autoComplete="off"
            variant="outlined"
            size="small"
            inputProps={{
              inputMode: 'decimal',
              type: 'text',
              style: { textAlign: 'right' }
            }}
            sx={{
              width: '100%',
              '& .MuiOutlinedInput-input': {
                padding: '4px 8px',
                fontSize: '13px',
                backgroundColor: '#edfaff',
                textAlign: 'center'
              }
            }}
          />
        );
      }
    }
  ];

  const handlePrint = () => {
    // Construct report URL (replace with your real one)
    const url = `http://localhost:63212/(S(lxwpeayzzyabhkr1uzlh4oth))/WMS/FreshPurchase?prntyp=FP&P_TransId=${
      headObj?.A_TransId || 0
    }`;
    console.log('Report URL:', url);

    setReportUrl(url);
    setReportModalOpen(true);
  };

  return (
    <div>
      {' '}
      <Dialog open={open} maxWidth="lg" fullWidth fullScreen={vMediaQuery}>
        <Toolbar sx={toolbar}>
          <DialogTitle
            sx={{ backgroundColor: '#0d73bb', color: 'white', padding: '0 4px !important' }}>
            Stock Transfer Distribution Detail
          </DialogTitle>
          <IconButton edge="end" color="inherit" onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <DialogContent sx={{ '&.MuiDialogContent-root': { padding: '10px !important' } }}>
          <Grid
            container
            spacing={1}
            columnSpacing={2}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{ alignItems: 'center' }}
            className="mb-2">
            <Grid item xs={12} sm={12} md={12}>
              <Grid
                container
                spacing={1}
                columns={{ xs: 12, sm: 12, md: 12 }}
                sx={{ alignItems: 'center' }}>
                <Grid item xs={12} sm={6} md={5}>
                  <Grid
                    container
                    spacing={1}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                    sx={{ alignItems: 'center' }}>
                    <Grid item xs={2} sm={3} md={2}>
                      <CmpTypographyField xcomponent={'span'} xText={'Doc.Type'} />
                    </Grid>
                    <Grid item xs={0.5} sm={0.5} md={1}>
                      <CmpTypographyField xcomponent={'span'} xText={':'} />
                    </Grid>
                    <Grid item xs={9.5} sm={8.5} md={8}>
                      <CmpTypographyField
                        xcomponent={'span'}
                        xText={`${headObj.A_VocTyp} - ${headObj.vocName} `}
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={6} md={2.7}>
                  <Grid
                    container
                    spacing={1}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                    sx={{ alignItems: 'center' }}>
                    <Grid item xs={4} sm={3} md={3}>
                      <CmpTypographyField xcomponent={'span'} xText={'Doc.No'} />
                    </Grid>
                    <Grid item xs={1} sm={0.5} md={1}>
                      <CmpTypographyField xcomponent={'span'} xText={':'} />
                    </Grid>
                    <Grid item xs={7} sm={8.5} md={8}>
                      <CmpTypographyField xcomponent={'span'} xText={headObj.A_VocNo} />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={6} md={2.1}>
                  <Grid
                    container
                    spacing={1}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                    sx={{ alignItems: 'center' }}>
                    <Grid item xs={4} sm={3} md={3}>
                      <CmpTypographyField xcomponent={'span'} xText={'Date'} />
                    </Grid>
                    <Grid item xs={1} sm={0.5} md={1}>
                      <CmpTypographyField xcomponent={'span'} xText={':'} />
                    </Grid>
                    <Grid item xs={7} sm={8.5} md={8}>
                      <CmpTypographyField
                        xcomponent={'span'}
                        xText={moment(headObj.vocDt).format('DD/MM/YYYY')}
                      />
                    </Grid>
                  </Grid>
                </Grid>

                <Grid item xs={6} sm={6} md={2.2}>
                  <Grid
                    container
                    spacing={1}
                    columns={{ xs: 12, sm: 12, md: 12 }}
                    sx={{ alignItems: 'center' }}>
                    <Grid item xs={4} sm={3} md={4}>
                      <CmpTypographyField xcomponent={'span'} xText={'Location'} />
                    </Grid>
                    <Grid item xs={1} sm={0.5} md={1}>
                      <CmpTypographyField xcomponent={'span'} xText={':'} />
                    </Grid>
                    <Grid item xs={7} sm={8.5} md={7}>
                      <CmpTypographyField xcomponent={'span'} xText={headObj.DCLocName} />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid
            container
            spacing={1}
            columns={{ xs: 12, sm: 12, md: 12 }}
            sx={{
              display: 'flex',
              justifyContent: vMediaQuery ? 'center' : 'end',
              alignItems: 'center'
            }}>
            <Grid item xs={4} sm={2} md={1}>
              <CmpButtonWithIcon
                xvariant={'contained'}
                xsize={'small'}
                xonClick={() => fSaveCheck(false)}
                xLabel={'Save'}
                xDisable={headObj?.A_Status === true}
              />
            </Grid>
            <Grid item xs={4} sm={2} md={1}>
              <CmpButtonWithIcon
                xvariant={'contained'}
                xsize={'small'}
                xonClick={() => fSaveCheck(true)}
                xLabel={'Post'}
                xColor={'success'}
                xDisable={headObj?.A_Status === true}
              />
            </Grid>
            <Grid item xs={4} sm={1} md={0.5}>
              <Tooltip title="Print">
                <IconButton color="primary" onClick={handlePrint} size="small">
                  <PrintOutlinedIcon />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>

          <Box
            sx={{
              height: '70vh',
              width: '100%',
              mt: '15px'
            }}>
            <DataGrid
              sx={{
                '& .editable-cell': {
                  backgroundColor: '#edfaff',
                  border: '1px solid lightgray',
                  borderRadius: '6px'
                },
                borderColor: 'primary.light',
                border: 1,
                '& .MuiDataGrid-columnHeaders': {
                  backgroundColor: '#0d73bb',
                  color: 'white'
                }
              }}
              rowHeight={30}
              headerHeight={30}
              rows={detailItems}
              columns={columns}
              getRowId={(row) => row.RowId}
              disableRowSelectionOnClick
              hideFooter
              disableSelectionOnClick
            />
          </Box>
        </DialogContent>
      </Dialog>
      <Dialog
        open={reportModalOpen}
        onClose={() => setReportModalOpen(false)}
        maxWidth="lg"
        fullWidth>
        <DialogTitle
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            color: 'white',
            backgroundColor: '#0d73bb'
          }}>
          Report
          <IconButton onClick={() => setReportModalOpen(false)}>
            <CloseIcon sx={{ color: 'white' }} />
          </IconButton>
        </DialogTitle>

        <DialogContent
          sx={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            height: '80vh',
            width: '100%'
          }}>
          {reportUrl ? (
            <iframe
              src={reportUrl}
              title="Report"
              style={{
                width: '90%',
                height: '90%',
                border: 'none',
                borderRadius: '8px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.2)'
              }}
            />
          ) : (
            <p>No report available</p>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};
